import IconCopy from '@apollo/icons/default/IconCopy.svg';
import { Button, Code } from '@apollo/orbit';
import copy from 'copy-to-clipboard';
import React, { useCallback } from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const LaunchIDHash = ({
  launchID,
  className,
  shortLaunchID,
}: {
  launchID: string;
  shortLaunchID: string;
  className?: string;
}) => {
  const handleCopyClick = useCallback(() => {
    copy(launchID);
  }, [launchID]);

  return (
    <Tooltip
      interactive
      label={
        <div className="flex items-center">
          <div>
            <p>{launchID}</p>
            <p>The unique ID for this launch.</p>
          </div>
          <Button
            className="ml-2"
            size="sm"
            variant="hidden"
            leftIcon={<IconCopy />}
            onClick={handleCopyClick}
          >
            Copy
          </Button>
        </div>
      }
    >
      <Code className={className}>{shortLaunchID}</Code>
    </Tooltip>
  );
};
